import React, { Component } from "react";
import { Grid, Row, Col, Button, Image } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import BackButton from "./BackButton.jsx";
import hyperlinks from "../../../src/util/hyperlinks";



export default class AdvisoryBoardChairman extends Component {
    render() {
        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
                <Grid className="with-background advisory-board-chairman-page">
                    <Banner heading="Chairman of the Board" />
                    <BackButton href={hyperlinks["advisoryBoard"]} text="❮ The Board" />
                    <Row className="advisory-board-chairman-content">
                        <Col md={4} mdOffset={2}>
                            <Image src="/assets/john-ringham-77e98a247beea1f4dcc886ea2ca30fbca2a8fa94a56433fc82a7d7c12fe31734.jpg" />
                        </Col>
                        <Col md={4}>
                            <h2>John Ringham</h2>
                            <p>
                                John is a Chartered Water and Environmental Manager with over 40 years experience in the operation and management of water utilities, most recently as the CEO of the South Australian Water Corporation. John begun his career in the United Kingdom and has experience includes water resource planning, water treatment and distribution operations, dam safety, desalination, economic regulation and change management. He played an active role in establishing WaterAid Australia and has served as a board member for Water Services Association of Australia and the South Australian Water Corporation.
                            </p>

                            <p>
                                John is married to Alexandra and has two children, three step children and a total of eight grandchildren. A lifelong Totenham Hotspur and England Rugby Union supporter.
                            </p>
                        </Col>
                    </Row>
                    <Row className="advisory-board-chairman-content-divider" >&nbsp;</Row>
                    <Row className="advisory-board-chairman-content" id="deputy">
                        <Col md={4} mdOffset={2}>
                            <Image src="/assets/Howard Neukrug_black&white-195d58fed755b6395aae58642524d820c0e969ee0bf10f252c30192c0d94bf85.JPG" />
                        </Col>
                        <Col md={4}>
                            <h2>Howard Neukrug</h2>
                            <p>
                                Mr. Neukrug is a <span className="blue-text"><strong>Senior Advisor to the Global Water Leaders Group</strong></span> and is the Deputy Chairman of the Leading Utilities of the World Network. He holds nearly 40 years of experience in the Water Industry, most recently as the CEO of Philadelphia Water. He is a national expert, advisor, lecturer and professor on the water sector; water utility management; innovations in water infrastructure, technology, science, policy and regulations; and sustainable and resilient urban systems.
                            </p>

                            <p>
                                Mr. Neukrug is a Professional Engineer, a member of the US National Drinking Water Advisory Council, and a Professor of Practice in Water Leadership and Innovation at the University of Pennsylvania.
                            </p>
                        </Col>
                    </Row>
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/AdvisoryBoardChairman.jsx.erb